import { useMemo, useRef } from 'react';

import LaunchIcon from '@mui/icons-material/Launch';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import IconButton from '@mui/material/IconButton';

import { useNavigate, useParams } from 'react-router';

import {
  generateUrl,
  MenuActions,
  MenuActionsProps,
  paths,
  SessionStorageItems,
  useBooleanState,
} from 'shared/base';

import { CLOUD_ASSET_UNIQUE_KEY } from '../../../constants/data';
import { AssetInventoryTableRow } from '../../../types';

export function ResourceDetailActionsMenu({ record }: { record?: AssetInventoryTableRow }) {
  const [menuShown, showMenu, hideMenu] = useBooleanState(false);
  const menuRef = useRef<HTMLButtonElement>(null);
  const { team } = useParams();
  const navigate = useNavigate();
  const actions = useMemo(() => {
    const actions: MenuActionsProps['actions'] = [];

    // Descoped for V1 - public/private sharing is not yet implemented
    // if (navigator) {
    //   actions.push({
    //     icon: ShareIcon,
    //     id: 'share',
    //     label: 'Share link',
    //     onClick: () => {
    //       navigator.clipboard.writeText(window.location.href);
    //       toast.success('Link copied to clipboard');
    //     },
    //   });
    // }

    if (record) {
      actions.push({
        icon: LaunchIcon,
        id: 'sql',
        label: 'Open in SQL Console',
        onClick: () => {
          sessionStorage.setItem(
            SessionStorageItems.NewSQLConsoleQuery,
            `SELECT * FROM ${record?.resource_type} WHERE ${CLOUD_ASSET_UNIQUE_KEY} = '${record?._cq_platform_id}'`,
          );

          navigate(
            generateUrl({
              pathname: paths.platform.team.sqlConsole.index,
              query: {
                team,
              },
            }),
          );
        },
        target: '_blank',
      });
    }

    return actions;
  }, [record, team, navigate]);

  return actions.length > 0 ? (
    <>
      <IconButton
        ref={menuRef}
        aria-expanded={menuShown ? 'true' : undefined}
        aria-haspopup="true"
        onClick={showMenu}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <MenuActions
        actions={actions}
        anchorEl={menuRef.current}
        id="resource-detail-actions-menu"
        onClose={hideMenu}
        open={menuShown}
        toggleId="resource-detail-actions-menu-toggle"
      />
    </>
  ) : null;
}
